import { DirectiveBinding, Directive } from 'vue'

import { directionHandler } from './config'

export const vResize = {
  mounted (el: HTMLElement, binding: DirectiveBinding) {
    if (typeof binding.value !== undefined && binding.value === false) return

    el.style.width = '320px'

    if (binding.modifiers.right) {
      directionHandler(el, 'ltr', {
        position: 'absolute',
        top: '0',
        right: '-2px',
        width: '8px',
        height: '100%',
        display: 'flex',
        'justify-content': 'center',
      })
    } else if (binding.modifiers.left) {
      directionHandler(el, 'rtl', {
        position: 'absolute',
        top: '0',
        left: '-4px',
        width: '8px',
        height: '100%',
        display: 'flex',
        'justify-content': 'center',
      })
    }
  },
} as Directive
